import { usePermissao } from "@/contexts/autorizacao/permissao";
import { ImpressaoAnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/components/ImpressaoAnaliseLaboratorial/ImpressaoAnaliseLaboratorial";
import { ModalCancelarAnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/components/ModalCancelarAnaliseLaboratorial/ModalCancelarAnaliseLaboratorial";
import { useAnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/hooks/useAnaliseLaboratorial";
import { AnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/model/AnaliseLaboratorial";
import { PaginaAnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/model/PaginaAnaliseLaboratorial";
import { STATUS_CERTIFICADO } from "@/contexts/laboratorio/analiseLaboratorial/model/STATUS_CERTIFICADO";
import { env } from "@/env";
import { useNetworkStatus } from "@/shared/hooks/useNetworkStatus";
import {
  CloseOutlined,
  EditOutlined,
  EyeOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import { Button, List, Space, Tooltip, Typography } from "antd";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { useReactToPrint } from "react-to-print";
export function ItemListCertificado({
  item,
  reloadItems,
}: {
  item: PaginaAnaliseLaboratorial["content"][number];
  reloadItems: () => void;
}) {
  const { isOnline } = useNetworkStatus();
  const [searchParams] = useSearchParams();
  const requisicaoRef = useRef<HTMLDivElement>(null);
  const { getAnaliseLaboratorialByIdApi } = useAnaliseLaboratorial();
  const { hasEnabledPermissao } = usePermissao();
  const navigate = useNavigate();
  const [requisicao, setRequisicao] = useState<AnaliseLaboratorial | null>(
    null
  );
  const [isOpenModalCancelar, setIsOpenModalCancelar] = useState(false);

  const handlePrint = useReactToPrint({
    contentRef: requisicaoRef,
    documentTitle: "certificado_analise_laboratorial",
    suppressErrors: true,
    preserveAfterPrint: true,
    pageStyle: "@page{size:A4 !important; }",
  });

  const handleMountRequisicao = async () => {
    const requisicao = await getAnaliseLaboratorialByIdApi(item.id!);
    setRequisicao(requisicao);
  };

  const redirectToEdit = () => {
    navigate(
      `/analises-laboratoriais/certificados/novo/${item.id}?${searchParams.toString()}`
    );
  };

  const redirectToView = () => {
    navigate(`/analises-laboratoriais/visualizar/${item.id}`);
  };

  const handleOpenModalCancelar = () => {
    setIsOpenModalCancelar(true);
  };

  const produtoDesc = item.produto
    ? `${item.produto?.produto?.nome} ${item.produto?.numeroRotulo}`
    : "Água";

  useEffect(() => {
    if (requisicao) {
      handlePrint();
    }
  }, [requisicao, handlePrint]);

  return (
    <>
      <List.Item
        extra={
          <Space>
            <Typography.Text>
              {STATUS_CERTIFICADO[item.situacao]}
            </Typography.Text>

            <Tooltip title="Informar Certificado" destroyOnHidden>
              <Button
                size="small"
                type="primary"
                ghost
                icon={<EditOutlined />}
                onClick={redirectToEdit}
                disabled={
                  !isOnline ||
                  item.situacao !== "SOLICITADO" ||
                  !hasEnabledPermissao("CERTIFICADO_CRIAR")
                }
              />
            </Tooltip>

            <Tooltip title="Imprimir" destroyOnHidden>
              <Button
                size="small"
                icon={<PrinterOutlined />}
                onClick={handleMountRequisicao}
                disabled={!isOnline || item.situacao === "CANCELADO"}
              />
            </Tooltip>

            <Tooltip title="Visualizar" destroyOnHidden>
              <Button
                size="small"
                icon={<EyeOutlined />}
                onClick={redirectToView}
                disabled={
                  !isOnline ||
                  item.situacao === "CANCELADO" ||
                  !hasEnabledPermissao("RAL_VISUALIZAR")
                }
              />
            </Tooltip>

            <Tooltip title="Cancelar" destroyOnHidden>
              <Button
                size="small"
                type="primary"
                danger
                ghost
                icon={<CloseOutlined />}
                onClick={handleOpenModalCancelar}
                disabled={
                  !isOnline ||
                  item.situacao === "CANCELADO" ||
                  !hasEnabledPermissao("RAL_CANCELAR")
                }
              />
            </Tooltip>
          </Space>
        }
      >
        <List.Item.Meta
          title={
            <Typography.Text
              strong
              style={{
                opacity: item.situacao === "CANCELADO" ? 0.6 : 1,
                color: isOpenModalCancelar ? "#d7263d" : undefined,
              }}
            >
              Requisição {item.id}
            </Typography.Text>
          }
          description={
            <Typography.Text
              style={{
                color: isOpenModalCancelar ? "#d7263d" : "#8c8c8c",
                fontSize: 12,
              }}
            >
              Produto: {produtoDesc}
              <br />
              Tipo Análise: {item.natureza}
              <br />
              Data Coleta: {dayjs(item.dataColeta).format("DD/MM/YYYY HH:mm")}
            </Typography.Text>
          }
        />
      </List.Item>

      <div style={{ display: "none" }}>
        <ImpressaoAnaliseLaboratorial
          ref={requisicaoRef}
          item={requisicao}
          marcadagua={env.REACT_APP_AMBIENTE}
        />
      </div>

      <ModalCancelarAnaliseLaboratorial
        isOpen={isOpenModalCancelar}
        onClose={() => setIsOpenModalCancelar(false)}
        requisicaoId={item.id!}
        reloadItems={reloadItems}
      />
    </>
  );
}
